<div class="container-fluid">
  <div class="row mb-4">
    <div class="card-deck col-12 d-flex">
      <jhi-bary-card class="col-6" titleKey="legal-notices.identity.title">
        <div body>
          <p>
            SI MILES 88 (BARY) <br />
            Hangar G2 Quai Armand Lalande 33300 BORDEAUX
          </p>
          <p>SIRET : 851 055 160 00028</p>
          <p>
            Email : victor.gonzalez@bary.app<br />
            Directeur de la Publication : Victor Gonzalez<br />
          </p>
        </div>
      </jhi-bary-card>
      <jhi-bary-card *ngIf="transporter" class="col-6" titleKey="legal-notices.operator.title">
        <div body>
          <p>
            {{ transporter.companyAddressFullname!! }}<br />
            {{ transporter.companyAddressStreetNumber ? transporter.companyAddressStreetNumber + ' ' : '' }}{{ transporter.companyAddressStreet }}
            <br />
            {{ transporter.companyAddressZipCode!! }} {{ transporter.companyAddressCity }}<br />
            {{ transporter.companyAddressCountry | countryName }}<br />
          </p>
          <p *ngIf="transporter.phone">Tel : {{ transporter.phone }}</p>
          <p *ngIf="transporter.website">Site web : {{ transporter.website }}</p>
        </div>
      </jhi-bary-card>
    </div>
  </div>
  <div class="row">
    <div class="card-deck col-12 d-flex">
      <jhi-bary-card class="col-6" titleKey="legal-notices.hoster.title">
        <p body>
          Google Cloud Platform - Google France<br />
          8, rue de Londres<br />
          75009 Paris France<br />
        </p>
      </jhi-bary-card>
      <jhi-bary-card class="col-6" titleKey="legal-notices.documents.title">
        <p class="d-flex flex-column" body>
          <a routerLink="/cgv" target="_blank" jhiTranslate="legal-notices.documents.cgv-transporter-link">CGV Transporteur</a>
          <a routerLink="/cgu" jhiTranslate="legal-notices.documents.cgu-platform-link">CGU Plateforme</a>
          <a href="/content/documents/CGS_PayZen.pdf" target="_blank" jhiTranslate="legal-notices.documents.cgs-payment-link">CGS Paiement en ligne</a>
          <a href="/content/documents/cg-axa.pdf" target="_blank" jhiTranslate="legal-notices.documents.cgu-assurance-link">Conditions générales d'assurance</a>
          <a href="/cookies" target="_blank" jhiTranslate="legal-notices.documents.cookies-policy-link">Politique d'utilisation des cookies</a>
        </p>
      </jhi-bary-card>
    </div>
  </div>
</div>
